exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".suggestion-slot[data-v-43b65661]{min-height:24px}.suggestion-text[data-v-43b65661]{padding:0;border:none;background:none;color:#000;text-decoration:underline;cursor:pointer}\n", ""]);

// exports
